// src/app/services/auth.service.ts
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private msalService: MsalService,
    private envService: EnvironmentService
  ) { }

  logout() {
    this.msalService.logout();
  }

  getAccount() {
    return this.msalService.instance.getActiveAccount();
  }

  async getAccessToken(): Promise<string> {
    const account = this.msalService.instance.getActiveAccount();
    if (!account) {
      throw new Error('No active account');
    }

    const request = {
      scopes: this.envService.getMsalGuardScopes(),
      account: account
    };

    try {
      const response = await this.msalService.instance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      console.error('Token acquisition failed:', error);
      throw error;
    }
  }
}